import { Masonry } from "@mui/lab";
import React, { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils/index";
import { isMobile } from "react-device-detect";
import { AiOutlinePlus } from "react-icons/ai";
import { Button, TextField } from "@mui/material";
import { getGlobal, updateGlobal } from "../../services/global.service";
import FloatingContainer from "../../components/FloatingContainer";
import ThemeButton from "../../components/ThemeButton";
import MediaCard from "../../components/MediaCard";
import MediaManager from "../../components/MediaManager";
import useMediaManager from "../../hooks/useMediaManager";
import Seperator from "components/Seperator";
import moment from "moment";
import { getCoursesList } from "services/course.service";
import SingleFaq from "components/SingleFaq";

function Setting(props) {
  const [data, setData] = useState({
    templates: [],
    mentorAgreement: "",
    privacyPolicy: "",
    termsConditions: "",
    contactUs: "",
    aboutUs: "",
    tagLine: "",
  });

  const [courses, setCourses] = useState([]);

  const [mediaManager, setMediaManager] = useMediaManager();

  const { setProgress, setToast, isRefreshed } = useOutletContext();

  useEffect(() => {
    async function api() {
      setProgress(true);
      try {
        const data = await getGlobal();
        console.log(data);
        if (data) {
          setData(data);
          setProgress(false);
        } else {
          // error

          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error

        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }

    async function coursesApi() {
      try {
        const filters = {
          status: "Published",
        };

        const data = await getCoursesList(filters);
        if (data) {
          setCourses(data);
        }
      } catch (error) {
        // error
        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }

    api();
    coursesApi();
  }, [isRefreshed]);

  const inputChangeHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
    setProgress(true);

    try {
      const res = await updateGlobal(data);
      setProgress(false);
      setToast({ success: true, message: "Settings Updated", autohide: 3000 });
    } catch (error) {
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <div>
        <div className="font-semibold my-2">Banners</div>
        <div className="flex gap-5 flex-wrap">
          {data.banners &&
            data.banners.map((banner, index) => {
              return (
                <MediaCard
                  media={banner}
                  size="small"
                  key={index}
                  courses={courses}
                  enableContext={true}
                  onChange={(ban) => {
                    const banners = data.banners;
                    banners[index] = ban;
                    setData({ ...data, banners });
                  }}
                  onClose={() => {
                    const banners = data.banners;
                    banners.splice(index, 1);
                    setData({ ...data, banners });
                  }}
                />
              );
            })}

          <div>
            <div
              className="bg-primary m-auto font-bold text-white h-full w-52 flex items-center justify-center rounded cursor-pointer min-h-[10rem]"
              onClick={() => {
                setMediaManager({
                  open: true,
                  type: "Photo,Video",
                  onSelect: (media) => {
                    const banners = data.banners;
                    // media.context = "62c6d00bb71a698fa837a5bf";
                    banners.push(media);
                    setData({ ...data, banners });
                  },
                });
              }}
            >
              <AiOutlinePlus size={100} color="white" />
            </div>
          </div>
        </div>
      </div>

      <Seperator label="General FAQs" />
      <h1 className="p-4 font-extrabold text-lg">General FAQs</h1>

      <div className=" p-5 grid gap-5">
        {data.faq &&
          data.faq.map((faq, index) => {
            return (
              <SingleFaq
                question={faq.question}
                answer={faq.answer}
                index={index}
                key={index}
                onChange={(sFaq) => {
                  const faq = [...data.faq];
                  faq[index] = sFaq;
                  setData({ ...data, faq });
                }}
                onDelete={() => {
                  const faq = [...data.faq];
                  faq.splice(index, 1);
                  setData({ ...data, faq });
                }}
              />
            );
          })}
        <div className="text-right">
          <Button
            size="small"
            onClick={() => {
              const faq = [...data.faq];
              faq.push({ question: "", answer: "" });
              setData({ ...data, faq });
            }}
          >
            NEw FAQ +
          </Button>
        </div>
      </div>

      <div>
        <Seperator label="Customize Data" />
        <div className="flex flex-col gap-5 m-5">
          <div className="grid md:grid-cols-4 mt-4 md:mt-9 gap-5 md:gap-10">
            <div className="font-bold col-span-1">Mentor Agreement:</div>
            <TextField
              multiline
              minRows={4}
              maxRows={10}
              className="flex-grow col-span-3"
              name="mentorAgreement"
              label="Message"
              value={data.mentorAgreement}
              onChange={inputChangeHandler}
            ></TextField>
          </div>

          <div className="grid md:grid-cols-4 mt-4 md:mt-9 gap-5 md:gap-10">
            <div className="font-bold col-span-1">Privacy Policy:</div>
            <TextField
              multiline
              minRows={4}
              maxRows={10}
              className="flex-grow col-span-3"
              name="privacyPolicy"
              label="Message"
              value={data.privacyPolicy}
              onChange={inputChangeHandler}
            ></TextField>
          </div>

          <div className="grid md:grid-cols-4 mt-4 md:mt-9 gap-5 md:gap-10">
            <div className="font-bold col-span-1">Terms & Conditions:</div>
            <TextField
              multiline
              minRows={4}
              maxRows={10}
              className="flex-grow col-span-3"
              name="termsConditions"
              label="Message"
              value={data.termsConditions}
              onChange={inputChangeHandler}
            ></TextField>
          </div>

          <div className="grid md:grid-cols-4 mt-4 md:mt-9 gap-5 md:gap-10">
            <div className="font-bold col-span-1">Contact Us:</div>
            <TextField
              multiline
              minRows={4}
              maxRows={10}
              className="flex-grow col-span-3"
              name="contactUs"
              label="Message"
              value={data.contactUs}
              onChange={inputChangeHandler}
            ></TextField>
          </div>

          <div className="grid md:grid-cols-4 mt-4 md:mt-9 gap-5 md:gap-10">
            <div className="font-bold col-span-1">About Us:</div>
            <TextField
              multiline
              minRows={4}
              maxRows={10}
              className="flex-grow col-span-3"
              name="aboutUs"
              label="Message"
              value={data.aboutUs}
              onChange={inputChangeHandler}
            ></TextField>
          </div>

          <div className="grid md:grid-cols-4 mt-4 md:mt-9 gap-5 md:gap-10">
            <div className="font-bold col-span-1">Tag Line:</div>
            <TextField
              className="flex-grow col-span-3"
              name="tagLine"
              label="Message"
              value={data.tagLine}
              onChange={inputChangeHandler}
            ></TextField>
          </div>

          <div className="my-4">
            <i>
              <h1 className="text-gray-500 text-sm">
                <span>Database created on</span>{" "}
                <b>
                  {moment(data.createdAt).format("dddd, MMMM Do YYYY, h:mm a")}
                </b>
              </h1>
            </i>
          </div>
        </div>
      </div>

      <MediaManager
        open={mediaManager.open}
        type={mediaManager.type}
        onClose={() => {
          setMediaManager({ ...mediaManager, open: false });
        }}
        onSelect={mediaManager.onSelect}
      />
      <FloatingContainer>
        <ThemeButton onClick={submitHandler}>Save Changes</ThemeButton>
      </FloatingContainer>
    </div>
  );
}

export default Setting;
